import PropTypes from 'prop-types';

const VenueShape = PropTypes.shape({
  announcement: PropTypes.oneOfType([PropTypes.shape({
    external_links: PropTypes.arrayOf(PropTypes.shape({
      link: PropTypes.string,
      link_category: PropTypes.string,
      link_label: PropTypes.string,
    })),
    headline: PropTypes.string,
    subheadline: PropTypes.string,
  }), PropTypes.oneOf([null])]),
  reopen: PropTypes.shape({
    date: PropTypes.string,
  }),
  // custom_affiliations: PropTypes.arrayOf(),
  collections: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    type_id: PropTypes.number,
    file_name: PropTypes.string,
    image: PropTypes.string,
    name: PropTypes.string,
    short_name: PropTypes.string,
    description: PropTypes.string,
  })),
  config: PropTypes.shape({
    allow_bypass_payment_method: PropTypes.oneOf([0, 1]),
    allow_multiple_resys: PropTypes.oneOf([0, 1]),
    enable_discovery: PropTypes.oneOf([0, 1]),
    enable_invite: PropTypes.oneOf([0, 1]),
    enable_resypay: PropTypes.oneOf([0, 1]),
    hospitality_included: PropTypes.oneOf([0, 1]),
  }),
  contact: PropTypes.shape({
    phone_number: PropTypes.string,
    url: PropTypes.string,
    menu_url: PropTypes.string,
  }),
  content: PropTypes.arrayOf(PropTypes.shape({
    attribution: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    body: PropTypes.string,
    display: PropTypes.shape({ type: PropTypes.string }),
    icon: PropTypes.shape({ url: PropTypes.string }),
    locale: PropTypes.shape({ language: PropTypes.string }),
    name: PropTypes.string,
    title: PropTypes.string,
  })),
  featureRecaptcha: PropTypes.bool,
  googleMapImageUrl: PropTypes.string,
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      fb_pixel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      foursquare: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      google: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      resy: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })]),
  // discrepencies between normalized data and non-normalized data
  images: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        id: PropTypes.string,
        url: PropTypes.string,
      }),
    ])
  ),
  map_images: PropTypes.shape({}),
  responsive_images: PropTypes.shape({}),
  inventory: PropTypes.shape({
    type: PropTypes.shape({
      id: PropTypes.number,
    }),
  }),
  // links: { deep: 'resy://resy.com/VenueDetails?venue_id=2014830', web: 'https://web.staging.resy.com/cities/new-york-ny/venues/taco-palace' },
  // locale: { currency: 'USD', time_zone: 'EST5EDT' },
  location: PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
    code: PropTypes.string,
    country: PropTypes.string,
    cross_street_1: PropTypes.string,
    cross_street_2: PropTypes.string,
    id: PropTypes.number,
    latitude: PropTypes.number,
    locality: PropTypes.string,
    longitude: PropTypes.number,
    neighborhood: PropTypes.string,
    postalCode: PropTypes.string,
    region: PropTypes.string,
  }),
  // custom_affiliation: { id: null },
  // venue_group: { id: 6249455, name: 'Taco Palace', venues: [] },
  // metadata: {
  //   description: 'Taco Palace is an American restaurant in the Flatiron neighborhood of New York.',
  //   keywords: ['book', 'dining', 'reservations', 'restaurant', 'new york', '10016', 'flatiron', 'american', 'ny times', '4.75 star'],
  // },
  name: PropTypes.string,
  price_range_id: PropTypes.number,
  currency_symbol: PropTypes.string,
  gdaConciergeBooking: PropTypes.bool,
  rater: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    scale: PropTypes.number,
    score: PropTypes.number,
    total: PropTypes.number,
  })),
  is_gdc: PropTypes.oneOf([0, 1]),
  is_global_dining_access: PropTypes.bool,
  is_global_dining_access_only: PropTypes.bool,
  is_rga: PropTypes.bool,
  gdc_perk: PropTypes.string,
  requires_reservation_transfers: PropTypes.oneOf([0, 1]),
  is_gns: PropTypes.oneOf([0, 1]),
  social: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    value: PropTypes.string,
  })),
  resy_select: PropTypes.oneOf([0, 1]),
  // ticket: { average: 425.0, average_str: '$425' },
  type: PropTypes.string,
  url_slug: PropTypes.string,
  favorite: PropTypes.bool,
  // user_login_preference: { mobile_first: 1 },
  // source: {
  //   name: null, logo: null, terms_of_service: null, privacy_policy: null,
  // },
  hide_allergy_question: PropTypes.bool,
  safety_categories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    value: PropTypes.string,
    order_num: PropTypes.number,
    items: PropTypes.arrayOf(PropTypes.shape({})),
  })),
  safety_info_url: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  is_active: PropTypes.oneOf([0, 1]),
  isResyCreditEligible: PropTypes.bool,
});

export default VenueShape;
